/*
 * @version: V1.0.0
 * @Date: 2022-12-05 15:18:22
 * @LastEditors: lzq
 * @LastEditTime: 2023-11-17 19:13:27
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\utils\importData.js
 * @Descripttion:
 */
// import  * as XLSX from '../assets/cdns/xlsx.js'

/**
 * 从Excel中读取数据并转换为产品JSON
 */
import XLSX from '@/assets/cdns/xlsx.js'
async function convertExcel(file) {
  // 读取文件
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (e) => {
      resolve(e.target.result)
    }
    reader.onerror = reject

    reader.readAsBinaryString(file)
  })
    .then((data) => {
      // 解析XLSX
      return XLSX.read(data, { type: 'binary' })
    })
    .catch((err) => {
      console.log(err)
    })
}

export { convertExcel }
